<div class="report-data-container p-0">
    <h2 class="mb-0 p-3 p-lg-4 screener-section-title">{{ heading }}</h2>
    <div class=" d-flex align-items-center mx-auto my-lg-4 justify-content-center status-div text-center not-covered-status">
       <div class="locked-text">No Data Available</div>
    </div>
 </div>
